import type { TasApplicationExtension as TasApplication } from 'tio-data/data/resources/tas-application.ext';

const UNCOUNTED_STATES = new Set(['TAS.AssistanceState.CREATED', 'TAS.AssistanceState.ABANDONED']);

/**
 * The application's current reimbursement amount, read from its REIMBURSEMENT assistances rather
 * than FINAL_APPROVED_TOTAL. An assistance amount edit (a held-funds reduction or a drawer edit)
 * does not rewrite that field, so once a reimbursement assistance exists the field can be stale.
 *
 * @param application - needs `tasAssistances` loaded for the result to be meaningful
 * @returns cents, signed (repayments subtract; CREATED and ABANDONED rows are skipped), or
 *   undefined when the application has no reimbursement assistance yet — callers then fall back
 *   to the application's approved-total field
 */
export function currentReimbursementTotal(
  application: Pick<TasApplication, 'tasAssistances'>
): number | undefined {
  const reimbursements = (application.tasAssistances ?? []).filter(
    (assistance) => assistance.manner === 'TAS.AssistanceManner.REIMBURSEMENT'
  );
  if (!reimbursements.length) return undefined;

  return reimbursements.reduce(
    (total, assistance) =>
      UNCOUNTED_STATES.has(assistance.state) ? total : total + assistance.amount,
    0
  );
}
